<template>
	<div v-if="unitData.list && unitData.list.length" class="m-menu flex-wrap">
		<div v-for="(item, i) in unitData.list" :key="i" class="item flex-column flex-center">
			<sub-image class="image" :src="item.img_url" mode="aspectFill" :background="false"></sub-image>
			<p v-if="unitData.show_title == 1" class="ellipsis">{{item.title}}</p>
		</div>
	</div>
	<p v-else class="unit-empty"></p>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-menu {
		padding: 10px;
		background: #fff;
		
		.item {
			width: 114px;
			margin-left: 6px;
			
			&:nth-child(3n+1) {
				margin-left: 0;
			}
			
			&:nth-child(n+4) {
				margin-top: 6px;
			}
			.image {
				height: 64px;
			}
			
			p {
				height: 20px;
				margin-top: 5px;
				line-height: 20px;
				font-size: 13px;
				text-align: center;
				color: #000
			}
		}
	}
</style>
